import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import * as serviceWorkerRegistration from './serviceWorkerRegistration';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

// Simby-3: service worker DESATIVADO. O PWA segurava usuários em builds antigos
// até fecharem todas as abas (descoberto ao vivo: SW novo "waiting" enquanto o
// antigo servia bundle defasado). unregister() remove SWs já instalados nos
// navegadores dos usuários na próxima visita — deploys passam a valer na hora.
serviceWorkerRegistration.unregister();
